var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33203 0.800781C2.12027 0.800781 0.332031 2.48967 0.332031 4.57856C0.332031 6.04523 1.27321 7.60078 2.35556 9.46745C2.96733 10.4897 3.57909 11.5563 4.09674 12.6674C4.1438 12.7563 4.23791 12.8008 4.33203 12.8008C4.42615 12.8008 4.52027 12.7563 4.56733 12.6674C5.08497 11.5563 5.69674 10.4897 6.3085 9.46745C7.39085 7.64523 8.33203 6.04523 8.33203 4.57856C8.33203 2.48967 6.5438 0.800781 4.33203 0.800781ZM4.33203 5.91189C3.53203 5.91189 2.92027 5.33411 2.92027 4.57856C2.92027 3.823 3.53203 3.24523 4.33203 3.24523C5.13203 3.24523 5.7438 3.823 5.7438 4.57856C5.7438 5.33411 5.13203 5.91189 4.33203 5.91189Z",
    fill: "#939090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fb1f5386ced10d5543cce41104584a07.svg";
export { ForwardRef as ReactComponent };